

























import Vue from 'vue'
import Development from '@/layout/Development.vue'

import { types, params } from '@/components/registration/module/types'

const defaultLayout = 'Blue'

export default Vue.extend({
  components: {
    DevelopmentLayout: () => import('@/layout/Development.vue'),
    TreatmentLayout: () => import('@/layout/Treatment.vue'),
    BlueLayout: () => import('@/layout/Blue.vue'),
  },
  computed: {
    layout(): string {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    },
  },
  data() {
    return {
      maintenance: false,
    }
  },
})
